import './assets/app.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import dayjs from 'dayjs'
import 'dayjs/locale/fr-ch'

import App from './App.vue'

import 'primevue/resources/themes/lara-light-teal/theme.css'
import 'primeicons/primeicons.css'
import PrimeVue from 'primevue/config'

import router from './router'
import InputNumber from 'primevue/inputnumber'
import Button from 'primevue/button'
import Calendar from 'primevue/calendar'
import RadioButton from 'primevue/radiobutton'
import Dropdown from 'primevue/dropdown'
import Card from 'primevue/card'
import InputText from 'primevue/inputtext'
import Steps from 'primevue/steps'
import Checkbox from 'primevue/checkbox'
import Timeline from 'primevue/timeline'
import isBetween from 'dayjs/plugin/isBetween'
import customParseFormat from 'dayjs/plugin/customParseFormat'

const app = createApp(App)
//use primevue
app.use(PrimeVue)
//add different components
app.component('Button', Button)
app.component('Calendar', Calendar)
app.component('RadioButton', RadioButton)
app.component('Dropdown', Dropdown)
app.component('Card', Card)
app.component('InputNumber', InputNumber)
app.component('InputText', InputText)
app.component('Steps', Steps)
app.component('Checkbox', Checkbox)
app.component('Timeline', Timeline)

app.use(createPinia())
app.use(router)

app.config.globalProperties.$dayjs = dayjs
dayjs.extend(isBetween)
dayjs.extend(customParseFormat)

//set language to french
dayjs.locale('fr-ch')

app.mount('#app')
